// src/pages/AboutUs.jsx — Broadway Holidays
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  FaHotel, FaBus, FaShip, FaStar,
  FaBullseye, FaLightbulb, FaLock, FaBolt,
  FaGlobe, FaShieldAlt, FaHeadset, FaMapMarkerAlt,
  FaTicketAlt, FaUsers
} from "react-icons/fa";

const NAV = "#0B1F3A", GLD = "#f0a500", RED = "#e8390e", GRN = "#059669";
const PJS = {fontFamily:"'Plus Jakarta Sans',sans-serif"};
const DS  = {fontFamily:"'DM Sans',sans-serif"};

const SERVICES = [
  { ico:<FaHotel/>,    title:"Hotel Accommodation",    sub:"Worldwide",             desc:"From boutique city hotels to 5-star beach resorts — as a wholesale bed bank we access live rates from over 2 million properties worldwide, ensuring the best available price for every stay." },
  { ico:<FaBus/>,      title:"Airport Transfers",       sub:"Private & Shared",      desc:"Seamless door-to-door transfers connecting you from airport to hotel and back. Private vehicles, minibuses, and executive cars available across all major destinations." },
  { ico:<FaShip/>,     title:"Cruise Bookings",         sub:"Ocean & River",         desc:"Handpicked ocean and river cruises with leading cruise lines worldwide. From Mediterranean escapes to world voyages — we'll find your perfect sailing." },
  { ico:<FaTicketAlt/>,title:"Activities & Excursions", sub:"1,000+ Experiences",    desc:"Tours, day trips, cultural experiences, and adventure activities. We curate the best things to do at every destination so your stay extends beyond the hotel room." },
];

const WHY = [
  "Best price promise — we match any comparable offer",
  "Expert UK-based advisors available 7 days a week",
  "Fully tailored accommodation with no hidden fees",
  "Secure booking — payment protected at every step",
  "500+ destinations worldwide from budget to luxury",
  "Personal service from first enquiry to safe return",
  "Flexible payment options including low deposits",
  "Trusted by thousands of UK travellers",
];

const TEAM_VALS = [
  {ico:<FaBullseye/>, title:"Customer-First",    body:"Every decision we make is guided by what's best for the traveller. Your satisfaction is our only business model."},
  {ico:<FaLightbulb/>,title:"Expert Knowledge",  body:"Our advisors are well-travelled specialists — real advice from people who genuinely know these destinations."},
  {ico:<FaLock/>,     title:"Trust & Security",  body:"UK-registered with transparent pricing and secure payment processing on every single booking."},
  {ico:<FaBolt/>,     title:"Speed & Efficiency",body:"Live rates, instant confirmations, and rapid response times. Your time is valuable and we treat it that way."},
];

const HERO_BADGES = [
  {ico:<FaShieldAlt/>,  label:"Secure Payments"},
  {ico:<FaHeadset/>,    label:"7-Day Support"},
];

const STORY_CARDS = [
  {ico:<FaHotel/>,      title:"Hotels",     val:"2M+ properties worldwide"},
  {ico:<FaBus/>,        title:"Transfers",  val:"600+ destinations covered"},
  {ico:<FaShip/>,       title:"Cruises",    val:"Leading cruise lines"},
  {ico:<FaTicketAlt/>,  title:"Activities", val:"1,000+ curated experiences"},
];

const Chk = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GRN} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:1}}><polyline points="20 6 9 17 4 12"/></svg>;
const Rt  = ({c="#fff"}) => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>;
const Ph  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const WA  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/></svg>;

export default function AboutUs() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar/>

      {/* HERO */}
      <div style={{background:`linear-gradient(135deg,${NAV} 0%,#1e3a5c 100%)`,padding:"60px 20px 64px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",inset:0,opacity:.04,backgroundImage:"radial-gradient(circle at 20% 50%,#fff 1px,transparent 1px)",backgroundSize:"32px 32px"}}/>
        <div style={{maxWidth:860,margin:"0 auto",textAlign:"center",position:"relative"}}>
          <nav style={{display:"flex",gap:6,alignItems:"center",justifyContent:"center",marginBottom:18,fontSize:12,...DS}}>
            <Link to="/" style={{color:"rgba(255,255,255,.6)",textDecoration:"none"}}>Home</Link>
            <span style={{color:"rgba(255,255,255,.3)"}}>›</span>
            <span style={{color:"#fff",fontWeight:600}}>About Us</span>
          </nav>
          <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(240,165,0,.15)",border:"1px solid rgba(240,165,0,.35)",borderRadius:20,padding:"5px 16px",marginBottom:18}}>
            <span style={{fontSize:12,fontWeight:700,color:GLD,...DS,letterSpacing:".06em"}}>UK WHOLESALE BED BANK</span>
          </div>
          <h1 style={{fontSize:"clamp(26px,4vw,44px)",fontWeight:900,color:"#fff",margin:"0 0 14px",lineHeight:1.2,...PJS}}>
            About Broadway Holidays
          </h1>
          <p style={{color:"rgba(255,255,255,.75)",fontSize:17,margin:"0 0 28px",...DS,lineHeight:1.7,maxWidth:620,marginLeft:"auto",marginRight:"auto"}}>
            Your trusted UK hotel wholesaler — operating as a bed bank to secure exclusive
            accommodation rates, transfers, cruises and activities across 500+ destinations worldwide.
          </p>
          {/* Hero badges — icons instead of emojis */}
          <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
            {HERO_BADGES.map((b,i)=>(
              <div key={i} style={{background:"rgba(255,255,255,.1)",border:"1px solid rgba(255,255,255,.2)",borderRadius:20,padding:"6px 14px",display:"flex",alignItems:"center",gap:7}}>
                <span style={{color:"#93c5fd",fontSize:11}}>{b.ico}</span>
                <span style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.9)",...DS}}>{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── YELLOW STATS BAR REMOVED ── */}

      <div style={{maxWidth:1060,margin:"0 auto",padding:"56px 20px 100px"}}>

        {/* STORY + SERVICES GRID */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:48,marginBottom:60,alignItems:"center"}} className="ab-2col">
          <div>
            <div style={{fontSize:11,fontWeight:800,color:RED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:10,...DS}}>Our Story</div>
            <h2 style={{fontSize:26,fontWeight:900,color:NAV,margin:"0 0 16px",lineHeight:1.25,...PJS}}>
              Making Exceptional Stays Accessible to Everyone
            </h2>
            <p style={{color:"#475569",lineHeight:1.9,fontSize:15,...DS,marginBottom:14}}>
              Beach Travels (Trading as Broadway Holidays) was founded with one clear ambition — to make outstanding accommodation
              genuinely accessible, without compromise on quality or price.
            </p>
            <p style={{color:"#475569",lineHeight:1.9,fontSize:15,...DS,marginBottom:14}}>
              We operate as a wholesale bed bank, giving us direct access to exclusive hotel rates
              from suppliers around the world — rates we pass straight on to our customers. Based in
              London and serving customers across the UK, our specialist team arranges hotel
              accommodation, airport transfers, cruise bookings, and destination activities for
              thousands of travellers every year. We combine the speed of a modern booking platform
              with the personal expertise of seasoned travel professionals.
            </p>
            <p style={{color:"#475569",lineHeight:1.9,fontSize:15,...DS}}>
              Whether you're planning a luxury Maldives escape, a family beach stay in Tenerife,
              or an ocean cruise through the Mediterranean — Broadway Holidays delivers.
            </p>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            {STORY_CARDS.map((c,i)=>(
              <div key={i} style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:12,padding:"18px 16px",textAlign:"center"}}>
                <div style={{width:44,height:44,borderRadius:12,background:`linear-gradient(135deg,${NAV},#1e3a5c)`,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 10px",color:"#fff",fontSize:18}}>
                  {c.ico}
                </div>
                <div style={{fontWeight:800,fontSize:14,color:NAV,...PJS,marginBottom:4}}>{c.title}</div>
                <div style={{fontSize:11,color:"#64748b",...DS}}>{c.val}</div>
              </div>
            ))}
          </div>
        </div>

        {/* SERVICES DETAIL */}
        <div style={{marginBottom:60}}>
          <div style={{textAlign:"center",marginBottom:32}}>
            <div style={{fontSize:11,fontWeight:800,color:RED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:10,...DS}}>Our Services</div>
            <h2 style={{fontSize:26,fontWeight:900,color:NAV,margin:"0 0 8px",...PJS}}>Everything for Your Stay</h2>
            <p style={{fontSize:15,color:"#64748b",margin:0,...DS}}>Four core services, delivered with expertise and care</p>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:16}} className="ab-2col">
            {SERVICES.map((s,i)=>(
              <div key={i} style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:14,padding:"24px",boxShadow:"0 2px 8px rgba(11,31,58,.04)",transition:"box-shadow .2s,transform .2s"}}
                onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 8px 24px rgba(11,31,58,.1)";e.currentTarget.style.transform="translateY(-2px)";}}
                onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 2px 8px rgba(11,31,58,.04)";e.currentTarget.style.transform="none";}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                  <div style={{width:48,height:48,background:`linear-gradient(135deg,${NAV},#1e3a5c)`,borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0,color:"#fff"}}>
                    {s.ico}
                  </div>
                  <div>
                    <div style={{fontWeight:800,fontSize:15,color:NAV,...PJS}}>{s.title}</div>
                    <div style={{fontSize:11,color:GLD,fontWeight:700,...DS}}>{s.sub}</div>
                  </div>
                </div>
                <p style={{fontSize:13.5,color:"#475569",lineHeight:1.75,margin:0,...DS}}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* WHY + VALUES */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:48,marginBottom:60}} className="ab-2col">
          <div>
            <div style={{fontSize:11,fontWeight:800,color:RED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:10,...DS}}>Why Choose Us</div>
            <h2 style={{fontSize:26,fontWeight:900,color:NAV,margin:"0 0 20px",lineHeight:1.25,...PJS}}>The Broadway Holidays Difference</h2>
            {WHY.map((t,i)=>(
              <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:13}}>
                <Chk/><span style={{fontSize:14.5,color:"#334155",...DS,lineHeight:1.6}}>{t}</span>
              </div>
            ))}
          </div>
          <div>
            <div style={{fontSize:11,fontWeight:800,color:RED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:10,...DS}}>Our Values</div>
            <h2 style={{fontSize:26,fontWeight:900,color:NAV,margin:"0 0 20px",lineHeight:1.25,...PJS}}>Built on Trust, Driven by Results</h2>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {TEAM_VALS.map((v,i)=>(
                <div key={i} style={{display:"flex",gap:14,alignItems:"flex-start",background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:10,padding:"14px 16px"}}>
                  <div style={{width:38,height:38,borderRadius:10,background:`linear-gradient(135deg,${NAV},#1e3a5c)`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:16,flexShrink:0}}>
                    {v.ico}
                  </div>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:NAV,...DS,marginBottom:3}}>{v.title}</div>
                    <div style={{fontSize:13,color:"#475569",...DS,lineHeight:1.6}}>{v.body}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div style={{background:`linear-gradient(135deg,${NAV} 0%,#1e3a5c 100%)`,borderRadius:18,padding:"44px 40px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:24,flexWrap:"wrap",position:"relative",overflow:"hidden"}}>
          <div style={{position:"absolute",right:-40,top:-40,width:200,height:200,borderRadius:"50%",background:"rgba(240,165,0,.08)"}}/>
          <div style={{position:"relative"}}>
            <h2 style={{fontSize:"clamp(18px,2.5vw,26px)",fontWeight:900,color:"#fff",margin:"0 0 8px",...PJS}}>
              Ready to book your next stay?
            </h2>
            <p style={{fontSize:15,color:"rgba(255,255,255,.65)",margin:0,...DS}}>
              Hotels, transfers, cruises, activities — all in one place, all at the best price.
            </p>
          </div>
          <div style={{display:"flex",gap:10,flexWrap:"wrap",position:"relative"}}>
            <button onClick={()=>navigate("/hotels")}
              style={{display:"inline-flex",alignItems:"center",gap:7,padding:"13px 24px",background:GLD,color:NAV,border:"none",borderRadius:10,fontSize:14,fontWeight:800,cursor:"pointer",...PJS}}>
              Search Hotels <Rt c={NAV}/>
            </button>
            <a href="tel:02030190055"
              style={{display:"inline-flex",alignItems:"center",gap:7,padding:"13px 20px",background:"rgba(255,255,255,.1)",color:"#fff",borderRadius:10,fontSize:14,fontWeight:700,textDecoration:"none",border:"1.5px solid rgba(255,255,255,.2)",...DS}}>
              <Ph/> 020 3019 0055
            </a>
            <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer"
              style={{display:"inline-flex",alignItems:"center",gap:7,padding:"13px 20px",background:"#22c55e",color:"#fff",borderRadius:10,fontSize:14,fontWeight:700,textDecoration:"none",...DS}}>
              <WA/> WhatsApp 
            </a>
          </div>
        </div>
      </div>

      <Footer/>
      <style>{`
        @media(max-width:820px){
          .ab-2col{grid-template-columns:1fr!important;gap:28px!important}
          .ab-revs{grid-template-columns:1fr!important}
        }
        @media(max-width:480px){.ab-stats{grid-template-columns:repeat(2,1fr)!important}}
      `}</style>
    </>
  );
}